import samtykke_nb from "../nb/samtykke";

const samtykke: typeof samtykke_nb = {
  knapper: {
    abort: {
      label: "Abort",
    },
    samtykke: {
      label: "Send copy to offended enterprise",
    },
    close: {
      label: "Close",
    },
    send_inn: {
      try_again: "Try again",
      label: "Submit",
    },
  },
  input: {
    samtykkeSvarType: {
      label:
        "Do you wish to send a copy of your report to the offended enterprise",
      type: {
        JA: "Yes",
        NEI: "No",
      },
    },
  },
  modal: {
    feiletInfo: "Something went wrong.",
    senderInn: "Saving answer",
    label: "Submit answer",
    suksess: "Answer is saved",
  },
};
export default samtykke;
